.section {
  color: var(--mantine-color-text);
}

.input {
  padding-left: calc(var(--mantine-spacing-xl) * 1);
  text-align: right;
}

.controls {
  display: none;
}
